/** Guarda el foco activo al abrir un overlay; devuelve función para restaurarlo al cerrar. */
export function mlvSaveFocus() {
  const a = document.activeElement;
  return () => {
    if (!a || !(a instanceof HTMLElement)) return;
    if (!document.body.contains(a)) return;
    try {
      a.focus({ preventScroll: true });
    } catch (_e) {
      try {
        a.focus();
      } catch (_e2) {
        /* ignore */
      }
    }
  };
}
